export default {"src":"/_next/static/media/close.85a90e68.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};